import { SearchEventsRefinements } from 'modules/search/pages/Events/components/SearchEventsRefinements';
import { SearchInternshipRefinements } from 'modules/search/pages/Internships/components/SearchInternshipRefinements';
import { SearchJobsRefinements } from 'modules/search/pages/Jobs/components/SearchJobsRefinements';
import { SearchOrgRefinements } from 'modules/search/pages/Orgs/components/SearchOrgRefinements';
import { SearchVolopsRefinements } from 'modules/search/pages/Volops/components/SearchVolopsRefinements';
import type { ListingType } from 'types/ListingType';
import { ALL_VOLOP_SOURCES } from 'utils/constants/general/volopSources';

type Args = {
  searchType: ListingType;
};

export function SearchRefinementsSwitch({ searchType }: Args) {
  switch (searchType) {
    case 'JOB':
      return <SearchJobsRefinements />;
    case 'INTERNSHIP':
      return <SearchInternshipRefinements />;
    case 'VOLOP':
      return <SearchVolopsRefinements sourcesAllowed={ALL_VOLOP_SOURCES} />;
    case 'ORG':
      return <SearchOrgRefinements />;
    case 'EVENT':
      return <SearchEventsRefinements />;
  }
}
